export default {
    app: {
        name: 'BZUCO Inspector',
        reseted: 'Tickets zurückgesetzt...',
        networkError: 'Serverfehler, bitte überprüfen Sie die Internetverbindung...',
        networkNotAvailable: 'Nicht verbunden'
    },
    menu: {
        test: 'Scanner-Test',
        settings: 'Einstellungen',
        admin: 'Verwaltung',
        resetTickets: 'Tickets zurücksetzen',
        resetState: 'App zurücksetzen',
        logout: 'Abmelden'
    },
    home: {
        login: 'Anmelden',
        lastEvent: 'Letztes Event / Zone prüfen',
        lastEvents: 'Letzte geladene<br />Events prüfen',
        lastZones: 'Letzte geladene<br />Zonen prüfen',
        chooseEvent: 'Event auswählen',
        checkEvents: 'Events<br />prüfen',
        checkZones: 'Zonen<br />prüfen',
        scanConfig: 'Scan QR code'
    },
    configScanner: {
        title: 'Configuration QR',
        notConfig: 'Unrecognized configuration code',
        loggedIn: 'Logged in:',
        setsSelected: 'Selected ticketsets:',
        zonesSelected: 'Selected zone:',
        loginRequiredTitle: 'Login required',
        loginRequiredMessage: 'You need to log in before loading ticketsets or zones.',
        ok: 'OK'
    },
    event: {
        chooseEvent: 'Event auswählen',
        chooseEventPast: 'Vergangene Events',
        confirm: 'Event-Auswahl bestätigen',
        showPast: 'Vergangene anzeigen'
    },
    zone: {
        chooseZone: 'Zone(n) auswählen',
        confirm: 'Zonen-Auswahl bestätigen'
    },
    ticketsets: {
        chooseTicketsets: 'Ticketsätze auswählen',
        selectAll: 'Alle auswählen',
        ticketCount: 'Ticketanzahl:'
    },
    scanner: {
        tickets: 'Tickets:',
        startReader: 'Scanner starten',
        startReaderDescription:
            'Der Browser benötigt eine Benutzerinteraktion, um Systemtöne abzuspielen. Bitte mit "OK" bestätigen.',
        specialWarning: 'Warnung',
        specialType: 'Ticket vom speziellen Typ:',
        refuse: 'Ablehnen',
        confirm: 'Bestätigen',
        messageSuccess: 'Code {code} akzeptiert',
        messageSuccessPrice: 'Code {code} akzeptiert<br /><big>Preis: <b>{price}</b></big>',
        messageSuccessTicketsetPrice: 'Code {code} akzeptiert<br /><big>Satz: <b>{ticketset} / {price}</b></big>',
        messageSuccessTicketset: 'Code {code} akzeptiert<br /><big>Satz: <b>{ticketset}</b></big>',
        messageSuccessEvent: 'Code {code} akzeptiert<br /><big>Event: <b>{event}</b>, Satz: {ticketset}</big>',
        messageSuccessNosend: 'Code {code} akzeptiert (nicht gesendet)',
        messageRead: 'Code {code} gelesen',
        messageUsed: 'Code {code} bereits verwendet',
        messageNotUsable: 'Code {code} nicht verwendbar',
        messageUnsend: 'Code {code} bereits verwendet (von mir, nicht gesendet)',
        messageNotFound: 'Code <b>{code}</b> nicht gefunden',
        messageBadSlot: 'Code {code} ist für diese Zone/Slot ungültig',
        messageExtra1: 'verwendet auf Gerät: <b>{device}</b>, Datum: <b>{date}</b>',
        manualTitle: 'Code manuell eingeben',
        loading: 'Tickets werden geladen...',
        nfcNotFound: 'Keine gültige Eintrittskarte auf der Karte'
    },
    login: {
        title: 'In die App einloggen',
        username: 'Benutzername',
        password: 'Passwort',
        login: 'Anmelden'
    },
    settings: {
        title: 'Einstellungen',
        sound: 'Ton',
        soundSub: 'Akustische Benachrichtigungen aktivieren',
        camera: 'Kamera',
        nfc_heading: 'NFC',
        nfc: 'NFC-Tags lesen',
        language: 'Sprache',
        langCs: 'Tschechisch',
        langEn: 'Englisch',
        langDe: 'Deutsch',
        langHr: 'Kroatisch',
        langHu: 'Ungarisch',
        langPl: 'Polnisch',
        langSk: 'Slowakisch',
        qTitle: 'Erweiterte Kameraeinstellungen',
        qPatchSize: 'Größe des Dekodierfensters',
        qFrequency: 'Dekodierfrequenz',
        groupDisplay: 'Gruppen-/Kategorienname bei der Kontrolle anzeigen',
        groupDisplayNone: 'Nichts anzeigen',
        groupDisplayTicketset: 'Ticketsatz-Name anzeigen',
        groupDisplayTicketsetPrice: 'Ticketsatz und Preis anzeigen',
        groupDisplayPrice: 'Preis anzeigen',
        groupDisplayEvent: 'Event und Ticketsatz anzeigen',
        olderEvents: 'Wie lange ältere Events nach Ablauf anzeigen',
        olderEventsWeek: 'Woche',
        olderEventsMonth: 'Monat',
        olderEvents3Month: '3 Monate',
        olderEvents6Month: '6 Monate',
        olderEventsYear: '1 Jahr',
        olderEventsAll: 'Alle Events anzeigen',
        olderEventsAllList: 'alle',
        showTicketCount: 'Ticketanzahl anzeigen',
        showStatistics: 'Statistik anzeigen',
        queueTitle: 'Codes in der Sende-Warteschlange',
        queueSending: 'Senden läuft',
        queueYes: 'JA',
        queueNo: 'NEIN',
        queueEmpty: 'Warteschlange ist leer'
    },
    statistics: {
        title: 'Statistik der Ticketnutzung',
        zone: 'Zone',
        today: 'Heute',
        total: 'Gesamt',
        refresh: 'Daten aktualisieren'
    },
    verify: {
        title: 'Ticket überprüfen',
        enterCode: 'Ticket-Code eingeben',
        verify: 'Überprüfen',
        scanHint: 'Code scannen oder manuell eingeben',
        notFound: 'Ticket nicht gefunden',
        found: 'Ticket gefunden',
        email: 'E-Mail',
        entries: 'Eintritte',
        people: 'Personen',
        entryPause: 'Eintrittspause (Min)',
        purchased: 'Gekauft',
        validUntil: 'Gültig bis',
        event: 'Event',
        ticketset: 'Ticketsatz',
        price: 'Preisstufe',
        zones: 'Zonen',
        noZones: 'Ticket ist keiner Zone zugeordnet.',
        slots: 'Slots',
        noSlots: 'Ticket ist keinem Slot zugeordnet.',
        usageForZone: 'Nutzung in Zone',
        remains: 'Verbleibend',
        usageLogs: 'Ticketnutzungsprotokoll',
        showDebug: 'Q',
        debugQuery: 'Query',
        debugData: 'Data',
        newSearch: 'Neue Überprüfung'
    }
} as const
